import React from 'react';

// Types
import { FilterItem } from '@src/types/search';

const List = ({
  filter,
  appliedFilters,
  onFilterUpdate
}: {
  filter: FilterItem;
  appliedFilters: any;
  onFilterUpdate: (input: string, applying: boolean, filterId: string, value: string) => void;
}) => {
  const { values, label } = filter;

  return (
    <div>
      <p className='b6--bold mb-4'>{label}</p>

      <div className='flex flex-wrap gap-4'>
        {values.map((value) => {
          const { input, id } = value;
          
          // Handle different appliedFilters formats - could be array or object
          let isApplied = false;
          if (Array.isArray(appliedFilters)) {
            // Legacy format: appliedFilters is an array of strings
            isApplied = appliedFilters.some((applied: string) => applied === input);
          } else if (appliedFilters && typeof appliedFilters === 'object') {
            // New format: appliedFilters is an object like {filterKey: [values]}
            // Check if any filter key contains this input value
            isApplied = Object.values(appliedFilters).some((filterValues: any) => {
              if (Array.isArray(filterValues)) {
                return filterValues.some((val) => {
                  // Handle both direct value match and JSON input parsing
                  if (val === input) return true;
                  
                  // Try to parse input as JSON to extract the actual filter value
                  try {
                    const parsedInput = JSON.parse(input);
                    if (parsedInput.taxonomyMetafield && parsedInput.taxonomyMetafield.value === val) {
                      return true;
                    }
                    if (parsedInput.productMetafield && parsedInput.productMetafield.value === val) {
                      return true;
                    }
                    // Add other filter type checks as needed
                  } catch (e) {
                    // Not JSON, continue with direct comparison
                  }
                  
                  return false;
                });
              }
              return false;
            });
          }
          // If appliedFilters is null/undefined, isApplied remains false

          return (
            <div
              key={id}
              className='flex items-center gap-2'
            >
              <input
                type='checkbox'
                id={id}
                onChange={() => onFilterUpdate(input, !isApplied, id, value.label)}
                className='appearance-none w-4 h-4 border border-black rounded checked:bg-checkbox-checked bg-cover'
                checked={isApplied}
              />

              <label
                className='b8--medium'
                title={value.label}
                htmlFor={id}
              >
                {value.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
